export function truncate(date: number, truncInterval: number): number {
  return date - (date % truncInterval)
}
